var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFunding = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33374 3.8576V18.0676C1.33639 18.8383 1.64522 19.5764 2.19225 20.1194C2.73928 20.6623 3.47966 20.9657 4.2504 20.9626H21.7504C22.5211 20.9657 23.2615 20.6623 23.8085 20.1194C24.3555 19.5764 24.6644 18.8383 24.667 18.0676V3.8576C24.6644 3.08686 24.3555 2.34876 23.8085 1.80579C23.2615 1.26283 22.5211 0.959509 21.7504 0.962609H4.2504C3.47966 0.959509 2.73928 1.26283 2.19225 1.80579C1.64522 2.34876 1.33639 3.08686 1.33374 3.8576Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 8.5542C25.0812 8.5542 25.417 8.21841 25.417 7.8042C25.417 7.38998 25.0812 7.0542 24.667 7.0542V8.5542ZM1.33374 7.0542C0.919527 7.0542 0.58374 7.38998 0.58374 7.8042C0.58374 8.21841 0.919527 8.5542 1.33374 8.5542V7.0542ZM14.4587 13.6858C14.8729 13.6858 15.2087 13.35 15.2087 12.9358C15.2087 12.5216 14.8729 12.1858 14.4587 12.1858V13.6858ZM1.33374 12.1858C0.919527 12.1858 0.58374 12.5216 0.58374 12.9358C0.58374 13.35 0.919527 13.6858 1.33374 13.6858V12.1858ZM20.292 13.6858C20.7062 13.6858 21.042 13.35 21.042 12.9358C21.042 12.5216 20.7062 12.1858 20.292 12.1858V13.6858ZM18.8337 12.1858C18.4195 12.1858 18.0837 12.5216 18.0837 12.9358C18.0837 13.35 18.4195 13.6858 18.8337 13.6858V12.1858ZM24.667 7.0542H1.33374V8.5542H24.667V7.0542ZM14.4587 12.1858H1.33374V13.6858H14.4587V12.1858ZM20.292 12.1858H18.8337V13.6858H20.292V12.1858Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFunding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/funding.3af3ee685351818c1ba5984ecc85626e.svg";